import {
  createRouter,
  createWebHistory
} from "vue-router";
import Languages from "../views/Languages.vue";
import Products from "../views/Products.vue";
import Solutions from "../views/Solutions.vue";
import Features from "../views/Features.vue";
import Casings from "../views/Casings.vue";
import GroupCasings from "../views/GroupCasings.vue";
import ThankYou from "../views/ThankYou.vue";
import OfferRequest from "../views/OfferRequest.vue";
import Meeting from "../views/Meeting.vue";



const routes = [{
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/",
    name: "languages",
    component: Languages,
  },
  {
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/products",
    name: "products",
    component: Products,
  },
  {
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/solutions",
    name: "solutions",
    component: Solutions,
  },
  {
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/features",
    name: "features",
    component: Features,
  },
  {
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/casings",
    name: "casings",
    component: Casings,
  },
  {
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/group-casings",
    name: "group-casings",
    component: GroupCasings,
  },
  {
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/thank-you",
    name: "thank-you",
    component: ThankYou,
  },
  {
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/offer-request",
    name: "offer-request",
    component: OfferRequest,
  },
  {
    // UserProfile will be rendered inside User's <router-view>
    // when /user/:id/profile is matched
    path: "/meeting",
    name: "meeting",
    component: Meeting,
  },
  {
    path: "/view",
    name: "view",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ "../views/View.vue"),
  },
  {
    path: "/finder",
    name: "finder",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ "../views/Finder.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return {
      top: 0
    }
  },
});

export default router;